export const environment = {
  production: true,
  appId: "02a42623-0d2a-4948-917e-d767d8f706dc",
  baseUrl: "https://amsuiteservices.neworg.net/",
  baseUrlApi: "https://amsuiteservices.neworg.net/api",
  demoUrlApi: "https://amsuiteservicesdemo.neworg.net",

  baseUrlAD: "https://amsuiteservicesad.neworg.net/",
  baseUrlADApi: "https://amsuiteservicesad.neworg.net/api",

  devUrlApi: "https://amsuiteservicesdev.neworg.net/api",
  devUrlADApi: "https://amsuiteservicesaddev.neworg.net/api",

  baseUrlADB2C: "https://amsuiteservices2.neworg.net/",
  baseUrlADB2CApi: "https://amsuiteservices2.neworg.net/api",


  routes: {
    config: {
      useHash: false,
      enableTracing: false
    }
  },
  appInsights: {
    instrumentationKey: '02ddf4cb-9c4d-44fc-bb74-a3ceb0900e93'
  },
  cryptingKey: "T7LiYWa2U8SWchbYMXRcYP3Y67w7pawt",

  // MSAL Azure AD B2C Configuration (Production)
  msalB2CInstance: 'https://amsuite.b2clogin.com/',
  msalB2CDomain: 'amsuite.onmicrosoft.com',
  msalB2CPolicy: 'B2C_1A_HRD_SUSI',
  msalClientId: '728246e6-43ea-4196-93f2-f7804f454faf',
  msalTenantId: '8dc18318-89eb-4518-9587-cd948be5758f',
  msalRedirectUri: 'https://amsuite.neworg.net/',
  msalPostLogoutRedirectUri: 'https://amsuite.neworg.net/login',
  msalApiScope: 'https://amsuite.onmicrosoft.com/am/Platform.Access',



  baseUrlAuthN: 'https://app-amsuite-authn-api-prod.azurewebsites.net',

  // URL mappings PROD: identity (to === from). Le app satellite in PROD girano sui propri
  // domini PROD, nessuna rimappatura. Il check di mapDevURL non si attiva su host PROD vero
  // (non contiene "-dev" ne' "localhost"), ma anche se attivasse questi mapping sarebbero no-op.
  devUrlMappings: [
    { from: 'amsuite.neworg.net', to: 'amsuite.neworg.net' },
    { from: 'crm.neworg.net', to: 'crm.neworg.net' },
    { from: 'calendar.neworg.net', to: 'calendar.neworg.net' },
    { from: 'reportbi.neworg.net', to: 'reportbi.neworg.net' },
    { from: 'dialog.neworg.net', to: 'dialog.neworg.net' },
    { from: 'fastpublisher.neworg.net', to: 'fastpublisher.neworg.net' },
    { from: 'suiteautomation.neworg.net', to: 'suiteautomation.neworg.net' },
    { from: 'attendancesheet.neworg.net', to: 'attendancesheet.neworg.net' },
    { from: 'partysharedarchive.neworg.net', to: 'partysharedarchive.neworg.net' },
    { from: 'billing.neworg.net', to: 'billing.neworg.net' },
    { from: 'refundedcosts.neworg.net', to: 'refundedcosts.neworg.net' },
    { from: 'amsuite-amcomunica.neworg.net', to: 'amsuite-amcomunica.neworg.net' },
    { from: 'amsuiteassistant.neworg.net', to: 'amsuiteassistant.neworg.net' },
    { from: 'manage-users.neworg.net', to: 'amsuite-manageusers.neworg.net' },
    { from: 'partyprofile.neworg.net', to: 'partyprofile.neworg.net' }
  ] as Array<{ from: string; to: string }>
};
